const initialState = {
  data: {},
  // The server's words when the last intern/athlete/ load was refused.
  error: null,
};

const internReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_ATHLETE_PROFILE_BY_INTERN':
      return { ...state, data: action.payload, error: null };

    // Never keep the previous athlete's doc after a failed load.
    case 'GET_ATHLETE_PROFILE_BY_INTERN_FAILED':
      return { ...state, data: {}, error: action.payload || null };
    
    default:
      return state;
  }
};

export default internReducer;
